// removed by extract-text-webpack-plugin
module.exports = {"button":"_1JF4l","hiddenLabel":"_1WOoS"};


//////////////////
// WEBPACK FOOTER
// ./app/components/search-button/search-button.scss
// module id = 1485
// module chunks = 0